export const ERROR_CODE = {
  BAD_REQUEST: 'BAD_REQUEST',
  UNAUTHORIZED: 'UNAUTHORIZED',
  FORBIDDEN: 'FORBIDDEN',
  NOT_FOUND: 'NOT_FOUND',
  CONFLICT: 'CONFLICT',
  VALIDATION_ERROR: 'VALIDATION_ERROR',
  INTERNAL_SERVER_ERROR: 'INTERNAL_SERVER_ERROR',
  NO_ORGANIZATION_ACCESS: 'NO_ORGANIZATION_ACCESS',
  PERSONAL_EMAIL_NOT_ALLOWED: 'PERSONAL_EMAIL_NOT_ALLOWED',
  PERSONAL_EMAIL_LOGIN_DENIED: 'PERSONAL_EMAIL_LOGIN_DENIED',
  LOGIN_METHOD_DENIED: 'LOGIN_METHOD_DENIED',
  AAL2_REQUIRED: 'AAL2_REQUIRED',
  MFA_REAUTH_REQUIRED: 'MFA_REAUTH_REQUIRED',
  ACCESS_CONTROL_DENIED: 'ACCESS_CONTROL_DENIED',
  PERMISSION_AND_ROLE_DENIED: 'PERMISSION_AND_ROLE_DENIED',
  /**
   * 要求した `(台帳, scope)` が組織設定で無効化されている 403。
   * 権限スコープ未保有（ACCESS_CONTROL_DENIED / PERMISSION_AND_ROLE_DENIED）とは異なり、
   * ユーザー自身の権限は足りているため `accessibles` は返らない。
   */
  DATA_SCOPE_DISABLED: 'DATA_SCOPE_DISABLED'
} as const;